/**
 * Created by linuxr on 2019/10/16.
 */
import ArcgisMap from './ArcgisMap.vue'
export default ArcgisMap



// WEBPACK FOOTER //
// ./src/components/arcgisMap/index.js